var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "tabBar" },
      _vm._l(_vm.tabBars, function (i, index) {
        return _c(
          "div",
          {
            staticClass: "tabItem",
            class: { itemActive: _vm.curIndex == index },
            on: {
              click: function ($event) {
                return _vm.changeTab(i, index)
              },
            },
          },
          [_vm._v(_vm._s(i))]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.curIndex == 0
      ? _c(
          "div",
          { staticClass: "addEditForm" },
          [
            _c(
              "el-form",
              {
                ref: "projectForm",
                attrs: {
                  model: _vm.form,
                  "label-width": "170px",
                  rules: _vm.rules,
                },
              },
              [
                _c(
                  "el-row",
                  { staticClass: "marRight20" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "项目名称：", prop: "matchName" } },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.matchName,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "matchName", $$v)
                            },
                            expression: "form.matchName",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "项目类型：", prop: "matchType" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            model: {
                              value: _vm.form.matchType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "matchType", $$v)
                              },
                              expression: "form.matchType",
                            },
                          },
                          _vm._l(_vm.list, function (i) {
                            return _c("el-option", {
                              key: i.id,
                              attrs: { label: i.matchTypeName, value: i.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "项目年份：", prop: "matchYear" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            model: {
                              value: _vm.form.matchYear,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "matchYear", $$v)
                              },
                              expression: "form.matchYear",
                            },
                          },
                          _vm._l(_vm.yearList, function (i) {
                            return _c("el-option", {
                              key: i.value,
                              attrs: { label: i.label, value: i.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "项目级别：" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            model: {
                              value: _vm.form.schoolType,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "schoolType", $$v)
                              },
                              expression: "form.schoolType",
                            },
                          },
                          _vm._l(_vm.typeList, function (i) {
                            return _c("el-option", {
                              key: i.valueData,
                              attrs: { label: i.keyData, value: i.valueData },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "项目开始结束时间：" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 11 } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "datetime",
                                placeholder: "选择开始时间",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                              },
                              model: {
                                value: _vm.form.startTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "startTime", $$v)
                                },
                                expression: "form.startTime",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          {
                            staticStyle: { "text-align": "center" },
                            attrs: { span: 2 },
                          },
                          [_vm._v("至")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 11 } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "datetime",
                                placeholder: "选择结束时间",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                              },
                              model: {
                                value: _vm.form.endTime,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "endTime", $$v)
                                },
                                expression: "form.endTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "专家承诺书：",
                          "label-width": "170px",
                        },
                      },
                      [
                        _c("FileUpload", {
                          attrs: { title: "承诺书上传" },
                          on: { successData: _vm.getUploadFileData },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "项目权限：" } },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            model: {
                              value: _vm.form.checkList,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "checkList", $$v)
                              },
                              expression: "form.checkList",
                            },
                          },
                          [
                            _c("el-checkbox", { attrs: { label: "教育局" } }),
                            _vm._v(" "),
                            _c("el-checkbox", { attrs: { label: "学校" } }),
                            _vm._v(" "),
                            _c("el-checkbox", { attrs: { label: "个人" } }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "是否开启报名表：" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.isNeedForm,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "isNeedForm", $$v)
                              },
                              expression: "form.isNeedForm",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("是"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 0 } }, [
                              _vm._v("否"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "majorWarp" },
                      [
                        _vm._l(_vm.mateList, function (i, j) {
                          return [
                            _c(
                              "el-row",
                              { key: j },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 20 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "材料名称：" } },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "请输入材料的名称",
                                          },
                                          model: {
                                            value: i.materialName,
                                            callback: function ($$v) {
                                              _vm.$set(i, "materialName", $$v)
                                            },
                                            expression: "i.materialName",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: "材料提交开始截止时间：",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 11 } },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                type: "datetime",
                                                placeholder: "选择开始时间",
                                                "value-format":
                                                  "yyyy-MM-dd HH:mm:ss",
                                              },
                                              model: {
                                                value: i.startTime,
                                                callback: function ($$v) {
                                                  _vm.$set(i, "startTime", $$v)
                                                },
                                                expression: "i.startTime",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          {
                                            staticStyle: {
                                              "text-align": "center",
                                            },
                                            attrs: { span: 2 },
                                          },
                                          [_vm._v("至")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 11 } },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                type: "datetime",
                                                placeholder: "选择结束时间",
                                                "value-format":
                                                  "yyyy-MM-dd HH:mm:ss",
                                              },
                                              model: {
                                                value: i.endTime,
                                                callback: function ($$v) {
                                                  _vm.$set(i, "endTime", $$v)
                                                },
                                                expression: "i.endTime",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "btnsGroup",
                                    attrs: { span: 4 },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          plain: "",
                                        },
                                        on: { click: _vm.addMajor },
                                      },
                                      [_vm._v("新增")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "danger",
                                          size: "mini",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeMajor(j)
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "majorWarp" },
                      [
                        _vm._l(_vm.workList, function (i, j) {
                          return [
                            _c(
                              "el-row",
                              { key: j },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 20 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      { attrs: { label: "作品清单名称：" } },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "请输入作品清单名称",
                                          },
                                          model: {
                                            value: i.name,
                                            callback: function ($$v) {
                                              _vm.$set(i, "name", $$v)
                                            },
                                            expression: "i.name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "btnsGroup",
                                    attrs: { span: 4 },
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "mini",
                                          plain: "",
                                        },
                                        on: { click: _vm.addWorks },
                                      },
                                      [_vm._v("新增")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "danger",
                                          size: "mini",
                                          plain: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeWorks(j)
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "submitBtn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.submit("projectForm")
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  { attrs: { size: "small" }, on: { click: _vm.isBack } },
                  [_vm._v("返回")]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("table", { attrs: { border: "1" } }, [
      _c("tr", [
        _c("th", [_vm._v("所属专业大类"), _c("br"), _vm._v("（代码）")]),
        _vm._v(" "),
        _c("th", [_vm._v("所属专业类"), _c("br"), _vm._v("（代码）")]),
        _vm._v(" "),
        _c("th", [_vm._v("对应行业"), _c("br"), _vm._v("（代码）")]),
        _vm._v(" "),
        _c("th", [_vm._v("主要职业类别"), _c("br"), _vm._v("（代码）")]),
        _vm._v(" "),
        _c("th", [_vm._v("主要岗位")]),
        _vm._v(" "),
        _c("th", [_vm._v("职业技能等级"), _c("br"), _vm._v("证书举例")]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", [_vm._v("电子信息大类"), _c("br"), _vm._v("（61）")]),
        _vm._v(" "),
        _c("td", [_vm._v("电子信息类"), _c("br"), _vm._v("（6101）   ")]),
        _vm._v(" "),
        _c("td", [
          _vm._v("计算机、通信和其他电子设备制造业"),
          _c("br"),
          _vm._v("（39）"),
        ]),
        _vm._v(" "),
        _c("td", [
          _vm._v("电子工程技术人员（2-02-09）"),
          _c("br"),
          _vm._v("电子设备装备调试人员（6-25-04）"),
        ]),
        _vm._v(" "),
        _c("td", [
          _vm._v(
            "电子研发与辅助研发、电子产品测试、电子产品销售、网络管理、软件测试、项目管理、生产管理、电子产品售后服务"
          ),
        ]),
        _vm._v(" "),
        _c("td", [
          _vm._v(
            " 计算机辅助设计绘图员（中级、高级）；1+X 证书：集成电路开发与测试（中级、高级）"
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("td", { staticClass: "zhu", attrs: { colspan: "6" } }, [
          _c("p", [
            _vm._v(
              "注：（1）所属专业大类和所属专业类：依据《普通高等学校高等职业教育（专科）专业目录》"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "zhu2" }, [
            _vm._v(
              "（2）对用行业（代码）：依据《国民经济行业分类与代码》（GB/T 4754-2017)"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "zhu2" }, [
            _vm._v(
              "（3）主要职业类别（代码）：依据《中华人民共和国职业分类大典》（2015 版）"
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "zhu2" }, [
            _vm._v("（4）职业技能等级证书应涵盖但不限于“1+X”中的“X”证书"),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }